import { motion } from "framer-motion";
import { Reveal } from "./motion";
import { FINAL_CTA, CONTACT_EMAIL } from "../../lib/siteData";

export const FinalCTA = () => {
  return (
    <section id="contact" data-testid="final-cta-section" className="relative bg-wine text-white overflow-hidden">
      <div className="mx-auto max-w-[1600px] px-6 md:px-12 py-28 md:py-40">
        <Reveal>
          <span className="font-body text-xs font-bold uppercase tracking-[0.25em] text-brand">
            {FINAL_CTA.overline}
          </span>
        </Reveal>

        <Reveal delay={0.05}>
          <h2 className="mt-8 font-heading text-[12vw] md:text-[8.5vw] font-bold uppercase leading-[0.85] tracking-tighter text-white">
            {FINAL_CTA.title[0]}<br />
            {FINAL_CTA.title[1]}<br />
            <span className="text-brand">{FINAL_CTA.title[2]}</span>
          </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-10 md:grid-cols-12 md:items-end">
          <Reveal delay={0.1} className="md:col-span-7">
            <p className="max-w-2xl font-body text-xl md:text-2xl font-light leading-relaxed text-white/80">
              {FINAL_CTA.body}
            </p>
          </Reveal>
          <Reveal delay={0.2} className="md:col-span-5 md:text-right">
            <a
              href={`mailto:${CONTACT_EMAIL}`}
              data-testid="final-cta-button"
              className="group inline-flex items-center gap-3 rounded-full bg-brand px-8 py-4 font-body text-sm font-semibold uppercase tracking-wide text-ink transition-transform duration-300 hover:scale-[1.03]"
            >
              {FINAL_CTA.cta.label}
              <span className="transition-transform duration-300 group-hover:translate-x-1">→</span>
            </a>
          </Reveal>
        </div>
      </div>

      <motion.div
        aria-hidden
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        className="pointer-events-none absolute -bottom-24 -right-24 h-72 w-72 rounded-full border-[3px] border-white/10"
      />
    </section>
  );
};
